import React, { useState } from 'react';
import './Styles.css';
import { FaWhatsapp } from 'react-icons/fa';

const Depoimentos = () => {
  const [comentarios, setComentarios] = useState([
    { nome: 'João S.', texto: 'Excelente serviço! Meu PC voltou a funcionar como novo.', avatar: 'https://randomuser.me/api/portraits/men/32.jpg' },
    { nome: 'Maria L.', texto: 'Atendimento rápido e eficiente. Resolveram meu problema em poucas horas.', avatar: 'https://randomuser.me/api/portraits/women/44.jpg' },
    { nome: 'Carlos M.', texto: 'Profissionais muito competentes e educados. Recomendo totalmente.', avatar: 'https://randomuser.me/api/portraits/men/12.jpg' },
    { nome: 'Ana P.', texto: 'Rápido, seguro e confiável. Meu notebook nunca esteve tão rápido.', avatar: 'https://randomuser.me/api/portraits/women/56.jpg' },
    { nome: 'Rafael T.', texto: 'Atendimento excelente, tiraram todas as minhas dúvidas e fizeram um ótimo trabalho.', avatar: 'https://randomuser.me/api/portraits/men/22.jpg' },
    { nome: 'Fernanda R.', texto: 'Serviço impecável e preço justo. Voltarei sempre que precisar.', avatar: 'https://randomuser.me/api/portraits/women/18.jpg' }
  ]);

  const [nome, setNome] = useState('');
  const [texto, setTexto] = useState('');

  const handleEnviar = () => {
    if(nome.trim() && texto.trim()) {
      setComentarios([{
        nome,
        texto,
        avatar: `https://randomuser.me/api/portraits/lego/${Math.floor(Math.random()*10)}.jpg`
      }, ...comentarios]);
      setNome('');
      setTexto('');
    }
  };

  return (
    <section className="depoimentos-section">
      <h2>O que nossos clientes dizem</h2>

      <div className="depoimento-form">
        <input 
          type="text" 
          placeholder="Seu nome" 
          value={nome} 
          onChange={(e) => setNome(e.target.value)} 
        />
        <textarea 
          placeholder="Escreva seu comentário..." 
          value={texto} 
          onChange={(e) => setTexto(e.target.value)} 
        />
        <button onClick={handleEnviar} className="btn-enviar">
          Enviar
        </button>
      </div>

      <div className="depoimentos-list">
        {comentarios.map((c, index) => (
          <div key={index} className="depoimento-card">
            <img src={c.avatar} alt={c.nome} className="avatar"/>
            <div className="depoimento-content">
              <span className="depoimento-nome">{c.nome}</span>
              <p>{c.texto}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Botão WhatsApp corrigido */}
      <a 
        href="https://wa.me/5515996879862?text=Ol%C3%A1!%20Vi%20sua%20landing%20page%20e%20quero%20agendar%20um%20servi%C3%A7o%20de%20manuten%C3%A7%C3%A3o."
        target="_blank"
        rel="noopener noreferrer"
        className="btn-whatsapp"
      >
        <FaWhatsapp /> Fale conosco
      </a>
    </section>
  );
};

export default Depoimentos;
